/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import SiteShell from './SiteShell.jsx'
import { PRIVACY_POLICY_CONTENT } from '../data/privacyPolicyContent.js'

export default function PrivacyPage() {
  return (
    <SiteShell variant="doc">
      <article className="pg-privacy" dir="rtl" dangerouslySetInnerHTML={{ __html: PRIVACY_POLICY_CONTENT }} />
    </SiteShell>
  )
}
